import { CapitalizeOnlyFirstLetter } from '../../Helper/string.helper';
import { Parents } from '../../Models/parents.models';

export const transformParentsListTableData = (
  parentsList: Array<Parents>
): any[] => {
  const transformDatForTable = parentsList.map((parent: Parents): any => {
    return {
      id: parent.id,
      parentalRelationship: CapitalizeOnlyFirstLetter(
        parent.parental_relationship
      ),
      name: parent.user.full_name,
      email: parent.user.email,
      mobile: parent.user.mobile,
      address: parent.user.address,
    };
  });
  return transformDatForTable;
};
